import CustomerServiceSummaryItem from "./CustomerServiceSummaryItem";
import { DocumentService } from "models/wizard/WizardState";
import SummaryModule from "../summaryModule/SummaryModule";

import "./CustomerServiceSummary.scss";

type Props = {
  onEditClick: () => void;
  services: DocumentService[];
  collapsed?: boolean;
};

export default function CustomerServiceSummary({
  onEditClick,
  services,
  collapsed
}: Props) {
  return (
    <SummaryModule
      moduleTitle="Digitala tjänster"
      info="Redigera digitala tjänster"
    >
      <ul className="wrapper">
        {services
          .filter((s) => s.enabled)
          .map((service) => {
            return (
              <CustomerServiceSummaryItem
                key={service.id}
                customerService={service}
              />
            );
          })}
      </ul>
    </SummaryModule>
  );
}
